// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
var Slides = /* #__PURE__ */ (function () {
    function Slides(value0) {
        this.value0 = value0;
    };
    Slides.create = function (value0) {
        return new Slides(value0);
    };
    return Slides;
})();
var ExtraSmall = /* #__PURE__ */ (function () {
    function ExtraSmall() {

    };
    ExtraSmall.value = new ExtraSmall();
    return ExtraSmall;
})();
var Small = /* #__PURE__ */ (function () {
    function Small() {

    };
    Small.value = new Small();
    return Small;
})();
var Medium = /* #__PURE__ */ (function () {
    function Medium() {

    };
    Medium.value = new Medium();
    return Medium;
})();
var ExtraMedium = /* #__PURE__ */ (function () {
    function ExtraMedium() {

    };
    ExtraMedium.value = new ExtraMedium();
    return ExtraMedium;
})();
var Large = /* #__PURE__ */ (function () {
    function Large() {

    };
    Large.value = new Large();
    return Large;
})();
var ExtraLarge = /* #__PURE__ */ (function () {
    function ExtraLarge() {

    };
    ExtraLarge.value = new ExtraLarge();
    return ExtraLarge;
})();
var serializeResponsiveSlides = function (v) {
    return Foreign_Generic_Class.encode(Foreign_Generic_Class.intEncode)(v.value0);
};
var serializeResponsiveBreakpoint = function (v) {
    if (v instanceof ExtraSmall) {
        return "xsmall";
    };
    if (v instanceof Small) {
        return "small";
    };
    if (v instanceof Medium) {
        return "medium";
    };
    if (v instanceof ExtraMedium) {
        return "extraMedium";
    };
    if (v instanceof Large) {
        return "large";
    };
    if (v instanceof ExtraLarge) {
        return "extraLarge";
    };
    throw new Error("Failed pattern match at Specular.Extra.Slider (line 23, column 3 - line 29, column 31): " + [ v.constructor.name ]);
};
var slider = function () {
    return function () {
        return Data_NamedParams.mkNamedParamsFn()()({
            responsive: [  ]
        })(function (params) {
            return function (node, v) {
                return $foreign.initSliderWithConfig(node, Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "type";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "rewind";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))({
                    rewind: params.rewind,
                    type: params.type
                }), Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                    return new Data_Tuple.Tuple(serializeResponsiveBreakpoint(v1.value0), serializeResponsiveSlides(v1.value1));
                })(params.responsive))));
            };
        });
    };
};
export {
    initSliderWithConfig
} from "./foreign.js";
export {
    ExtraSmall,
    Small,
    Medium,
    ExtraMedium,
    Large,
    ExtraLarge,
    serializeResponsiveBreakpoint,
    Slides,
    serializeResponsiveSlides,
    slider
};
//# sourceMappingURL=index.js.map
